import { Injectable } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { GlobalTrackingService } from './global-tracking.service';
import { StorageService } from './storage.service';
import { ActionType, Country, LoginStatus, pageData, PageReadyData, userData } from '../models/global-tracking.model';
import { TERMS_OF_USE_DATA } from '../models/terms-of-use-tracking.model';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseTrackingService {

  constructor(
    private globalAnalytic: GlobalTrackingService,
    private storageService: StorageService,
    private authService: AuthService
  ) { }

  pageLoadTrackingData(): void {
    let loginStatus: string
    this.authService.isUserLoggedIn().subscribe((data) => {
      data ? loginStatus = LoginStatus.LOGGED_IN : loginStatus = LoginStatus.LOGGED_OUT
    });
    const pageData: pageData = {
      path: TERMS_OF_USE_DATA.PATH,
      title: TERMS_OF_USE_DATA.TITLE,
      country: Country.COUNTRY,
      language: this.storageService.selectedLanguage || '',
      template: TERMS_OF_USE_DATA.TEMPLATE,
    };

    const user: userData = {
      loginStatus: loginStatus,
      role: this.storageService?.userRoles || '',
      company: this.storageService?.defaultLegalEntity?.name || '',
      companyId:
        this.storageService?.defaultLegalEntity?.uid || '',
    };

    const pageLoadData: PageReadyData = {
      page: pageData,
      user: user,
    };
    this.globalAnalytic.sendPageReadyData(ActionType.PAGE_READY, pageLoadData)
  }
}
